import React from 'react';
import classNames from 'classnames';

const Pills = ({ color, label }) => (
    <div className={
        classNames('sl__item__pill', color === 'green' ? 'sl__item__pill__green' : 'sl__item__pill__blue')
    }>{label}</div>
);

Pills.defaultProps = {
    color: 'green',
    label: null,
};

export default Pills;



// WEBPACK FOOTER //
// ./src/sections/SmartList/Pill.tsx